import React from "react";
import {
  Box,
  Button,
  ButtonGroup,
  Typography,
  Grid,
  Paper,
  useTheme,
} from "@mui/material";
import PostItem from "./PostItem";

const PostList = ({ posts, filter, onEdit, onDelete, setFilter }) => {
  const theme = useTheme();

  // ✅ Correct filter logic
  const filteredPosts =
    filter === "all" ? posts : posts.filter((post) => post.status === filter);

  return (
    <Box
      sx={{
        py: 3,
        px: { xs: 2, sm: 3 },
        backgroundColor: theme.palette.background.default,
        borderRadius: 2,
        transition: "all 0.3s ease",
      }}
    >
      {/* Filter Header */}
      <Box sx={{ textAlign: "center", mb: 3 }}>
        <Typography
          variant="h6"
          sx={{
            mb: 2,
            fontWeight: 600,
            color: theme.palette.text.primary,
          }}
        >
          Filter Posts
        </Typography>

        <ButtonGroup
          variant="outlined"
          sx={{
            backgroundColor: theme.palette.background.paper,
            borderRadius: 0,
            overflow: "hidden",
            boxShadow:
              theme.palette.mode === "dark"
                ? "0 4px 15px rgba(0,0,0,0.4)"
                : "0 4px 10px rgba(0,0,0,0.1)",
          }}
        >
          <Button
            onClick={() => setFilter("all")}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              px: 3,
              py: 1,
              color:
                filter === "all"
                  ? theme.palette.primary.main
                  : theme.palette.text.secondary,
              borderColor:
                filter === "all"
                  ? theme.palette.primary.main
                  : "rgba(255,255,255,0.1)",
              "&:hover": {
                backgroundColor: "rgba(199, 164, 93, 0.1)",
              },
            }}
          >
            All
          </Button>

          <Button
            onClick={() => setFilter("active")}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              px: 3,
              py: 1,
              color:
                filter === "active"
                  ? theme.palette.primary.main
                  : theme.palette.text.secondary,
              borderColor:
                filter === "active"
                  ? theme.palette.primary.main
                  : "rgba(255,255,255,0.1)",
              "&:hover": {
                backgroundColor: "rgba(199, 164, 93, 0.1)",
              },
            }}
          >
            Active
          </Button>

          <Button
            onClick={() => setFilter("inactive")}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              px: 3,
              py: 1,
              color:
                filter === "inactive"
                  ? theme.palette.primary.main
                  : theme.palette.text.secondary,
              borderColor:
                filter === "inactive"
                  ? theme.palette.primary.main
                  : "rgba(255,255,255,0.1)",
              "&:hover": {
                backgroundColor: "rgba(199, 164, 93, 0.1)",
              },
            }}
          >
            Inactive
          </Button>
        </ButtonGroup>
      </Box>

      {/* Posts Grid */}
      <Grid container spacing={3} justifyContent="center">
        {filteredPosts.length > 0 ? (
          filteredPosts.map((post) => (
            <Grid item xs={12} sm={6} md={4} key={post._id || post.id}>
              <Paper
                elevation={3}
                sx={{
                  p: 2,
                  borderRadius: 3,
                  backgroundColor: theme.palette.background.paper,
                  transition: "all 0.3s ease",
                  border: "1px solid rgba(255,255,255,0.08)",
                  "&:hover": {
                    transform: "translateY(-4px)",
                    boxShadow: "0 6px 20px rgba(199, 164, 93, 0.25)",
                  },
                }}
              >
                <PostItem post={post} onEdit={onEdit} onDelete={onDelete} />
              </Paper>
            </Grid>
          ))
        ) : (
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ mt: 4, textAlign: "center" }}
          >
            No posts found for the selected filter.
          </Typography>
        )}
      </Grid>
    </Box>
  );
};

export default PostList;
